export class ScanItem{
    itemQya:string;
    location:string;
    constructor(){
        this.itemQya='';
        this.location='';
    }
} 